import { Navigate, useLocation } from "react-router-dom";

/* Indirizzi del vecchio sito (o inesistenti) → home page, se possibile alla sezione più pertinente. */
const SECTION_KEYWORDS = [
    ["contatti", ["contatt", "contact", "preventiv", "richiest"]],
    ["assistenza", ["assistenz", "support", "ricambi", "manutenz"]],
    ["christ", ["christ", "lavaggio", "autolavagg", "portal", "tunnel", "self", "istobal", "wash"]],
    ["autoriparatore", ["officin", "ravaglioli", "autoriparat", "sollevat", "ponte", "gommist", "carrozz", "revision", "beta", "abac"]],
    ["realizzazioni", ["realizzazion", "galler", "lavori", "portfolio", "foto"]],
    ["chi-siamo", ["chi-siamo", "chisiamo", "azienda", "about", "storia"]],
    ["servizi", ["serviz", "prodott", "product", "catalog", "scaffal", "depuraz", "copertur", "impiant"]],
];

export const sectionForPath = (pathname) => {
    const p = decodeURIComponent(pathname).toLowerCase();
    const hit = SECTION_KEYWORDS.find(([, words]) => words.some((w) => p.includes(w)));
    return hit ? hit[0] : null;
};

export default function LegacyRedirect() {
    const { pathname } = useLocation();
    const section = sectionForPath(pathname);
    return <Navigate to={section ? `/#${section}` : "/"} replace />;
}
